export default (props, vars) => props?.['name'] === 'file-text';
